<div class="licensee-main modal-dialog">
    <div class="content">
        {{langService.getText('IDS_LICENSEE_TEXT')}}<br />{{dataService.getLicenseeName()}}
    </div>
    <div class="modal-button-container">
        <div class="modal-button" (click)="dialogsService.closeLicensee()">{{langService.getText('IDS_LICENSEE_CLOSE')}}</div>
    </div>
</div>
